(function ($, Drupal) {
  Drupal.behaviors.buttons = {
    attach: function (context, settings) {
      const quantityBtn = document.querySelectorAll('.form-item-quantity-0-value');

      if (quantityBtn && quantityBtn.length > 0) {
        quantityBtn.forEach(function (element) {
          var quantityLbl = element.querySelector('label[for=edit-quantity-0-value]');

          if (quantityLbl) {
            quantityLbl.innerHTML = 'Cantidad:';
          }
        });
      }

      const addCartBtn = document.querySelector('input.button--add-to-cart');

      if (addCartBtn) {
        addCartBtn.value = 'Agregar a la Cotización';
      }
    }
  };
})(jQuery, Drupal);
